import { SmartSendItemApiModel } from '~/lib/api/smartsend/types';
import { TariffSystemLength } from '~/lib/types/tariff-systems';
const GetTariffSystemFromItem = (item: SmartSendItemApiModel): string =>
  item.State?.validation?.QuoteState?.Quote?.Service?.TariffSystem || 'HS';

export const GetTariffSystemLengthFromItem = (item: SmartSendItemApiModel): number => {
  return TariffSystemLength[GetTariffSystemFromItem(item)] || TariffSystemLength.HS;
};

export default GetTariffSystemFromItem;
